export default __webpack_public_path__ + "static/media/mail_success.fafc8e54.gif";